import { useMemo, useState } from 'preact/hooks';
import discordIcon from '@assets/social-icons/discord-icon.png';
import instagramIcon from '@assets/social-icons/instagram-icon-social.png';
import twitterIcon from '@assets/social-icons/twitter-icon.png';
import threadsIcon from '@assets/social-icons/threads.png';
import { useLocation } from 'react-router';

const links = [
  {
    title: 'U.S. Privacy Notice',
    href: 'https://www.stjude.org/legal/u-s-privacy-policy-statement.html',
  },
  {
    title: 'Linking Policy',
    href: 'https://www.stjude.org/legal/linking-policy.html',
  },
  {
    title: 'Ad Choices',
    href: 'https://www.stjude.org/legal/u-s-privacy-policy-statement.html#advertising',
  },
  {
    title: 'Notice of Privacy Practices (HIPAA)',
    href: 'https://www.stjude.org/legal/notice-of-privacy-practices.html',
  },
  {
    title: 'Notice of Non-Discrimination',
    href: 'https://www.stjude.org/legal/notice-of-non-discrimination.html',
  },
  {
    title: 'Site Map',
    href: 'https://www.stjude.org/sitemap.html',
  },
  {
    title: 'Your Opt-Out Rights',
    type: 'action',
    action: (e: MouseEvent) => {
      e.preventDefault();
      window.OneTrust?.ToggleInfoDisplay();
    },
  },
  {
    title: 'Disclaimer / Registrations / Copyright Statement',
    href: 'https://www.stjude.org/legal.html',
  },
  {
    title: 'Washington Health Privacy Notice',
    href: 'https://www.stjude.org/legal/u-s-privacy-policy-statement/washington-health-privacy-notice.html',
  },
];

export default function Footer({ constrictWidth = false }) {
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState('');
  const showDisclaimer = useMemo(() => {
    return ['/overlays/alerts', '/overlays/gifts-that-give'].includes(
      currentPath
    );
  }, [currentPath]);

  const showSocialIcons = useMemo(() => {
    return currentPath !== '/';
  }, [currentPath]);

  setCurrentPath(location.pathname);

  return (
    <>
      <div className="bg-base-200 w-full flex items-center justify-center">
        <footer
          className={`footer footer-horizontal footer-center bg-base-200 text-base-content rounded p-10 ${constrictWidth ? 'max-w-screen-2xl' : 'max-w-full'}`}
        >
          <nav className="grid md:grid-cols-3 gap-4">
            {links.map((link) => {
              if (link.type === 'external') {
                return (
                  <a
                    key={link.href}
                    href={link.href}
                    rel="noopener noreferrer"
                    target="_blank"
                    className="link link-hover text-xs text-nowrap"
                  >
                    {link.title}
                  </a>
                );
              }

              return (
                <button
                  onClick={link.action}
                  className="link link-hover text-xs text-nowrap"
                  key={link.title}
                >
                  {link.title}
                </button>
              );
            })}
          </nav>
          <nav>
            {showSocialIcons && (
              <div className="grid grid-flow-col gap-4">
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href="https://www.discord.gg/stjudeplaylive"
                >
                  <div
                    className="aspect-square w-[24px] h-[24px] object-contain bg-base-content/60"
                    style={`mask: url(${discordIcon}) no-repeat center; mask-size: contain;`}
                  />
                </a>
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href="https://www.instagram.com/stjudeplaylive/"
                >
                  <div
                    className="aspect-square w-[24px] h-[24px] object-contain bg-base-content/60"
                    style={`mask: url(${instagramIcon}) no-repeat center; mask-size: contain;`}
                  />
                </a>
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href="https://www.twitter.com/stjudeplaylive"
                >
                  <div
                    className="aspect-square w-[24px] h-[24px] object-contain bg-base-content/60"
                    style={`mask: url(${twitterIcon}) no-repeat center; mask-size: contain;`}
                  />
                </a>
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  href="https://threads.net/stjudeplaylive"
                >
                  <img
                    src={`${threadsIcon}`}
                    alt="threads"
                    width={24}
                    height={24}
                  />
                </a>
              </div>
            )}
          </nav>
          <aside>
            {showDisclaimer && (
              <p className="max-w-screen-lg text-xs mb-4 mt-2">
                Disclaimer: When you make a donation using any of these tools,
                your donation will be used to support breakthrough research,
                treatment and cures. Items listed in this section are
                representative of services and supplies that are part of the
                treatment and care of children of St. Jude. The cost of each
                item or service is an approximation and will vary based on
                actual costs incurred and individual patient needs. Your
                donations will be used to support the general operating expenses
                of St. Jude. Thanks to generous supporters, families never
                receive a bill from St. Jude for treatment, travel, housing or
                food — because all a family should worry about is helping their
                child live.
              </p>
            )}
            <p>
              Copyright © {new Date().getFullYear()} St. Jude Children&apos;s
              Research Hospital, a not-for-profit, section 501(c)(3).
            </p>
          </aside>
        </footer>
      </div>
    </>
  );
}
